import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { orgDashboardEditEventRoute } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardEditEventPageContainerLoadable } from './OrgDashboardEditEventPageContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardEditEventRoute>,
) {
  await OrgDashboardEditEventPageContainerLoadable.load();
}

export default function OrgDashboardEditEventHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <OrgDashboardEditEventPageContainerLoadable />;
}
